import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import { breakpoints, colors, fontFamily, functions } from '../../ui/variables';

export const LoginStyle = styled.main`
  background-color: ${colors.veryPaleBlue};
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone + 36}px 20px 36px;
  width: 100%;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: ${headerVariables.main.height.iphone + 64}px 64px 64px;
  }

  .login-content {
    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      align-items: stretch;
      background-color: ${colors.softBlue};
      border-radius: 20px;
      display: flex;
      max-width: 1344px;
      min-height: 60vh;
      overflow: hidden;
      position: relative;
      width: 100%;
    }

    .image-section {
      display: none;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        display: block;
        flex-basis: 50%;
        position: relative;
      }

      .logo-wrapper {
        left: 50%;
        position: absolute;
        top: ${functions.responsive.vw(
          40,
          64,
          breakpoints.ipadLandscape.width,
          breakpoints.fullHd.width
        )};
        transform: translateX(-50%);
        width: 25%;

        @media (min-width: ${breakpoints.fullHd.width}px) {
          top: 64px;
        }

        svg,
        .logo {
          display: block;
          height: auto;
          width: 100%;
        }
      }

      .login-illustration {
        bottom: 0;
        display: block;
        height: auto;
        left: 50%;
        max-height: 448px;
        position: absolute;
        transform: translateX(-50%);
        width: calc(100% - (2 * 32px));
      }
    }

    .form-section {
      background-color: ${colors.white};
      border-radius: 20px;
      padding: 40px 44px;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        border-radius: 0;
        border-bottom-left-radius: 20px;
        border-top-left-radius: 20px;
        flex-basis: 50%;
        padding: 80px 64px;
      }

      .form-content {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          margin: 0 auto;
          max-width: 468px;
        }

        .form-head {
          .form-head-title {
            ${fontFamily.sourceSansPro.bold};
            color: ${colors.softBlue};
            font-size: 30px;
            line-height: 36px;
            margin-bottom: 8px;
          }

          .form-head-description {
            ${fontFamily.sourceSansPro.regular};
            color: ${colors.veryDarkGray};
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 58px;
          }
        }

        .forgot-password {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.softBlue};
          font-size: 14px;
          line-height: 18px;
          margin: 12px 0 56px;
        }

        .test-software {
          ${fontFamily.sourceSansPro.regular}
          color: ${colors.grayishBlue};
          font-size: 13px;
          line-height: 18px;
          margin-top: 30px;

          a {
            ${fontFamily.sourceSansPro.bold};
            color: ${colors.softBlue};
          }
        }

        .go-to-register {
          ${fontFamily.sourceSansPro.regular}
          color: ${colors.veryDarkGray};
          font-size: 14px;
          line-height: 18px;
          margin-top: 56px;

          a {
            ${fontFamily.sourceSansPro.bold};
            color: ${colors.softBlue};
          }
        }
      }
    }
  }
`;
